module.exports = __webpack_public_path__ + "static/img/statistics_2.da43a71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/statistics_2.png
// module id = zZ8o
// module chunks = 1